import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

// reactstrap components
import { Container } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import { useContext } from "react";
import Loader from "../components/common/Loader";
import NotFoundPage from "../views/NotFoundPage";
import Sidebar from "../components/navbars/Sidebar";
import MainNavBar from "../components/navbars/MainNavBar";
import OfflineMeetingsPage from "../views/OfflineMeetingsPage";
import OfflineMeetingTreePage from "../views/OfflineMeetingTreePage";
import OfflineBrowsePage from "../views/OfflineBrowsePage";
import OfflineBoardPage from "../views/OfflineBoardPage";

interface IParams {
  tenant: string;
}

const OfflineDashboardLayout: React.FC<RouteComponentProps<IParams>> = ({
  history,
  location,
  match,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { currentTenant, tenantArray, offlineDashboardLoaded, setOfflineDashboardLoaded, setCurrentTenant, user, loadCssTheme } = rootStore.offlineStore;

  useEffect(() => {
    try {
      
      loadCssTheme(match.params.tenant).then(() => 
      {
        //console.log("loadCssTheme:", JSON.stringify(theme));
     
        document.body.classList.remove("form-membership");
        document.body.classList.add("pt-0", `bg-${theme!.backgroundColor}`);
        setOfflineDashboardLoaded();
      }
      ).catch((error) => 
      {
        console.log("QUI2s! " + error);
        history.push("/home");
      });
      
      //setCurrentTenant(match.params.tenant);
      //document.body.classList.remove("form-membership");
      //document.body.classList.add("pt-0", `bg-${theme!.backgroundColor}`);
      //ssetOfflineDashboardLoaded();
    } catch (error) {
      console.log("QUI! " + error);
      history.push("/home");
    }
  }, [
    setCurrentTenant,
    setOfflineDashboardLoaded,
    history,
    match.params.tenant,
    theme
  ]);

  if (!offlineDashboardLoaded) return <Loader />;

  return (
    <>
      <Sidebar tenant={currentTenant!} currentUrl={location.pathname} goBack={history.goBack} />
      <MainNavBar currentTenant={currentTenant!} allTenants={tenantArray!} user={user!} goBack={history.goBack} currentUrl={location.pathname}/>
      <Container fluid>
        <Switch>
          <Route exact path="/:tenant/meetings" component={OfflineMeetingsPage} />
          <Route exact path="/:tenant/meeting/:meetingId" component={OfflineMeetingTreePage} />
          <Route exact path="/:tenant/board" component={OfflineBoardPage} />
          {/* <Route exact path="/:tenant/search" component={SearchPage} /> */}
          <Route exact path="/:tenant/browse/:treetype/:sourceId/content/:nodeId" component={OfflineBrowsePage} /> 
          <Route component={NotFoundPage} />
        </Switch>
      </Container>
    </>
  );
};

export default observer(OfflineDashboardLayout);
